import { Button, Divider, InputBase, Stack, Typography } from "@mui/material"
import { useState } from "react";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";
import faradayApi from "../../api/faradayApi";
import { useForm } from "../../hooks";
import { LoginLayout } from "../layout/LoginLayout"

export const RecoverPassword = () => {

  const [formValues, handleInputChange] = useForm({ userEmail: '' });
  const { userEmail } = formValues;
  const [isWaitingAnswer, setIsWaitingAnswer] = useState(false)

  const onLogin = async (e) => {
    e.preventDefault();
    try {
      setIsWaitingAnswer(true)
      const { data } = await faradayApi.post('/user/recoverPassword', { 'email': userEmail });
      data.status === true &&
        Swal.fire({
          confirmButtonColor: '#001B60',
          title: t("login.succesfullMsg"),
          text: t("login.recoverText"),
          icon: "success"
        })
    } catch (error) {
      Swal.fire({
        confirmButtonColor: '#001B60',
        title: t("login.errorTitle"),
        text: t("login.errorMsg"),
        icon: "error"
      })
    }
    setIsWaitingAnswer(false)
  }

  const { t } = useTranslation('global');

  return (
    <LoginLayout>
      <Stack width='100%' height='100%' justifyContent='center' alignItems='center'>
        <Stack width='40%' maxWidth={476} height={300} minWidth={300} bgcolor='white' borderRadius={3} padding='30px 0px' >
          <Typography marginBottom='10px' variant='h5' textAlign='center' fontWeight={700}>{t("login.titleRecover")}</Typography>

          <Divider />
          <form onSubmit={onLogin} style={{ padding: '20px 15px', height: '320px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
            <Typography variant='overline' color='secondary'>{t("login.labelUser")}</Typography>
            <InputBase fullWidth
              name="userEmail"
              size="small"
              variant="standard"
              onChange={handleInputChange}
              value={userEmail}
            />
            <Button disabled={isWaitingAnswer}  type='submit' variant="contained">{t("login.recoverButton")}</Button>
          </form>

          <Typography textAlign='center' color='secondary'> {t("login.recoverText")}</Typography>

        </Stack>
      </Stack>
    </LoginLayout>
  )
}
